import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Target, Zap, Shield } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function MechanismReveal() {
  const pillars = [{
    icon: Target,
    label: 'EL CONDUCTOR',
    color: 'text-[#B91C1C]',
    bg: 'bg-[#FEF2F2]',
    border: 'border-[#FECACA]',
    desc: 'La planta que ataca el problema directamente',
    example: 'Ej: Cúrcuma → bloquea COX-2 como el ibuprofeno'
  }, {
    icon: Zap,
    label: 'EL ACTIVADOR',
    color: 'text-[#C17817]',
    bg: 'bg-[#FFFBEB]',
    border: 'border-[#FDE68A]',
    desc: 'Lo que multiplica su absorción hasta 2,000%',
    example: 'Ej: Pimienta Negra → activa la curcumina'
  }, {
    icon: Shield,
    label: 'EL ESCUDO',
    color: 'text-[#2D5A3D]',
    bg: 'bg-[#F0F4EC]',
    border: 'border-[#BBF7D0]',
    desc: 'Lo que protege tu cuerpo mientras sana',
    example: 'Ej: Aceite de Coco → transporta al tejido inflamado'
  }];
  return <section className="py-12 px-4 bg-[#FEFCF6] text-center relative overflow-hidden" data-id="element-424">
      <div className="max-w-[800px] mx-auto relative z-10" data-id="element-425">
        <div className="inline-block bg-[#F0F4EC] text-[#2D5A3D] font-bold px-4 py-1 rounded-full text-xs uppercase tracking-widest mb-6 border border-[#2D5A3D]/20" data-id="element-426">
          Presentando
        </div>

        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2C1810] mb-4" data-id="element-427">
          La Medicina Natural
        </h2>

        <p className="text-[#5C4A3A] max-w-2xl mx-auto mb-12 text-lg" data-id="element-428">
          El único sistema de sinergia herbal diseñado específicamente para
          adultos de 50+ que quieren recuperar el control de su salud — desde su
          propia cocina.
        </p>

        {/* Product Showcase Card */}
        <div className="bg-white rounded-2xl shadow-green-medium border border-[#E8DFD0] p-8 md:p-12 relative overflow-hidden mb-12" data-id="element-429">
          <div className="absolute -right-20 -bottom-20 text-[#F0F4EC] opacity-50" data-id="element-430">
            <svg width="300" height="300" viewBox="0 0 24 24" fill="currentColor" data-id="element-431">
              <path d="M12 2C7.5 2 4 6.5 4 12s4.5 9 9 9c5 0 8-4 8-9 0-6-5-10-9-10zm0 16c-3 0-5-3-5-7 0-3 2-6 5-6s5 3 5 6c0 4-2 7-5 7z" data-id="element-432" />
            </svg>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-10 relative z-10" data-id="element-433">
            {/* Book Images — Cover + Interior */}
            <div className="w-full md:w-1/2" data-id="element-434">
              <motion.div initial={{
              y: 20,
              opacity: 0
            }} whileInView={{
              y: 0,
              opacity: 1
            }} transition={{
              duration: 0.8
            }} className="relative flex flex-col gap-4" data-id="element-435">
                <div className="relative" data-id="element-436">
                  <div className="absolute -inset-4 bg-gradient-to-b from-[#C17817]/30 via-[#2D5A3D]/20 to-[#C17817]/20 rounded-2xl blur-3xl opacity-50" data-id="element-437"></div>
                  <img src="https://cdn.magicpatterns.com/uploads/iEvJvZ7j4aAvadThqLH4ef/heylloyd-image-1771822033591.png" alt="La Medicina Natural — Portada" className="relative w-full h-auto rounded-xl shadow-2xl transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500" data-id="element-438" />
                </div>
                <div className="relative rounded-xl overflow-hidden border border-[#E8DFD0] shadow-lg" data-id="element-439">
                  <div className="bg-[#F0F4EC] px-3 py-1.5 border-b border-[#E8DFD0] flex items-center gap-2" data-id="element-440">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#2D5A3D]" data-id="element-441"></span>
                    <span className="text-[10px] font-bold text-[#2D5A3D] uppercase tracking-wider" data-id="element-442">
                      Interior del manual
                    </span>
                  </div>
                  <img src="https://cdn.magicpatterns.com/uploads/6cpxJnZhyig1RtCkiU9kza/heylloyd-image-1771822135812.png" alt="Vista interior de La Medicina Natural" className="w-full h-auto block" data-id="element-443" />
                </div>
              </motion.div>
            </div>

            {/* Product Details */}
            <div className="w-full md:w-1/2 text-left" data-id="element-444">
              <div className="flex items-center gap-1 mb-2" data-id="element-445">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-[#C17817] fill-[#C17817]" data-id="element-446" />)}
                <span className="text-xs text-[#8B7355] ml-2 font-medium" data-id="element-447">
                  Bestseller Internacional
                </span>
              </div>

              <h3 className="text-2xl font-serif font-bold text-[#2C1810] mb-2" data-id="element-448">
                LA MEDICINA NATURAL
              </h3>
              <p className="text-[#5C4A3A] text-sm mb-6 pb-6 border-b border-[#E8DFD0]" data-id="element-449">
                Por Shanon Greef | Maestra Herborista
                <br data-id="element-450" />
                <span className="text-[#2D5A3D] font-medium" data-id="element-451">
                  +20 Años de Práctica Clínica
                </span>
              </p>

              <ul className="space-y-3 mb-8" data-id="element-452">
                {['Protocolos de Sinergia Herbal Documentados', 'Ingredientes de tu propia cocina', 'Resultados desde la primera semana', 'Para adultos de 50+ que quieren resultados reales'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#2C1810] text-sm font-medium" data-id="element-453">
                    <Check className="w-5 h-5 text-[#2D5A3D] shrink-0" data-id="element-454" />
                    {item}
                  </li>)}
              </ul>

              <div className="flex items-center gap-4" data-id="element-455">
                <div className="text-center" data-id="element-456">
                  <span className="text-xs text-[#8B7355] line-through block" data-id="element-457">
                    VALORADO EN $149
                  </span>
                  <span className="text-3xl font-bold text-[#2D5A3D]" data-id="element-458">
                    HOY: $6.97
                  </span>
                </div>
                <a href="https://pay.hotmart.com/D104591124J?off=pf8xmxms" onClick={() => trackAddToCart()} className="bg-gradient-to-r from-[#B91C1C] to-[#991B1B] hover:opacity-90 text-white px-6 py-3 rounded-lg font-bold text-sm uppercase tracking-wide transition-opacity shadow-lg" data-id="element-459">
                  Reclamar Copia
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* 3-Pillar System */}
        <div className="text-center mb-8" data-id="element-460">
          <p className="text-xs font-bold uppercase tracking-widest text-[#C17817] mb-2" data-id="element-461">
            El Secreto Detrás de Cada Protocolo
          </p>
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#2C1810] mb-2" data-id="element-462">
            El Sistema de Tres Pilares
          </h3>
          <p className="text-[#5C4A3A] max-w-xl mx-auto text-sm" data-id="element-463">
            Cada una de las 9 sinergias del manual sigue esta arquitectura
            exacta. Es la razón por la que funcionan cuando todo lo demás falló.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-464">
          {pillars.map((pillar, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className={`${pillar.bg} border ${pillar.border} rounded-xl p-6 text-left`} data-id="element-465">
              <div className={`inline-flex items-center gap-2 mb-3 ${pillar.color}`} data-id="element-466">
                <pillar.icon className="w-5 h-5" data-id="element-467" />
                <span className="font-bold text-xs uppercase tracking-widest" data-id="element-468">
                  {pillar.label}
                </span>
              </div>
              <p className="font-serif font-bold text-[#2C1810] text-base mb-2" data-id="element-469">
                {pillar.desc}
              </p>
              <p className={`text-xs ${pillar.color} font-medium italic`} data-id="element-470">
                {pillar.example}
              </p>
            </motion.div>)}
        </div>

        <div className="bg-[#2D5A3D] text-white rounded-xl p-5 text-center" data-id="element-471">
          <p className="font-serif italic text-lg" data-id="element-472">
            "Una hierba sola es un susurro. Dos hierbas combinadas correctamente
            son un grito que tu cuerpo no puede ignorar."
          </p>
          <p className="text-[#C17817] font-bold text-sm mt-2" data-id="element-473">
            — Shanon Greef, Maestra Herborista
          </p>
        </div>
      </div>
    </section>;
}